export const LinksManagerConfig =  [
    { label : "None", value : "" },

    { label : "Page", value : "pagelink", defaultLabel: "Select page", dataSource : "pages", linkOpenOptions : true, hrefValue: "/{x}", usesHref: true},

    { label : "Course", value : "courselink", defaultLabel: "Select course", dataSource : "courses" ,linkOpenOptions : true, usesHref: true, productType: 'course',
        linkToExtraOptions : [
            { label : "Overview page" , value : "internalPage" , hrefValue: "/course/{x}" , isDefault : true},
            { label : "Payout page" , value : "paymentPage", hrefValue: "/payment?product_id={x}"},
        ]
    },

    { label : "Course Activity", value : "courseContentslink", defaultLabel: "Select course", dataSource : "courseContents",linkOpenOptions : true, usesHref: true, hrefValue: "/path-player?courseid={x}&unit={y}"},

    { label : "Bundle", value : "bundlelink" ,defaultLabel: "Select bundle", dataSource : "bundles",linkOpenOptions : true, usesHref: true, productType: 'bundle',
        linkToExtraOptions : [
            { label : "Overview page" , value : "bundlePage" , hrefValue:"/bundle/{x}" , isDefault : true},
            { label : "Payout page" , value : "bundlePaymentPage" , hrefValue: "/payment?product_id={x}&type=bundle" },
        ]
    },

    { label : "Subscription", value : "subscriptionlink",defaultLabel: "Select subscription", dataSource : "subscriptions",linkOpenOptions : true, usesHref: true, productType: 'subscription',
        linkToExtraOptions : [
            { label : "Overview page" , value : "subscriptionPage", hrefValue: "/subscription/{x}" , isDefault : true},
            { label : "Payout page" , value : "subscriptionPaymentPage" , hrefValue: "/payment?product_id={x}&type=subscription"},
        ]
    },

    { label : "Blog post", value : "blogPostslink", defaultLabel: "Select blog post",dataSource : "blogPosts",linkOpenOptions : true, hrefValue: "/blog/{x}" , usesHref: true},

    { label : "App", value : "appslink" ,defaultLabel: "Select app",linkOpenOptions : true, usesHref: true,
        data : [
            { label : "Daily news" , value : "dailynews" , hrefValue: "/dailynews"},
            { label : "Profile" , value : "profile" , hrefValue: "/profile"},
            { label : "Blog" , value : "blog" , hrefValue:"/blog"},
            { label : "Social" , value : "social" ,hrefValue: "/social"},
            { label : "Best resources" , value : "workpad" , hrefValue:"/workpad"},
            { label : "Inbox" , value : "inbox" , hrefValue: "/inbox"},
            { label : "Account" , value : "account" , hrefValue:"/account"},
            { label : "People" , value : "people" , hrefValue: "/people"},
        ]
    },
    { label : "Social link", value : "socialNetwork" ,defaultLabel: "Select network",linkOpenOptions : true,
        data : [
            { label : "Facebook" , value : "facebook" },
            { label : "Twitter" , value : "twitter" },
            { label : "Linkedin" , value : "linkedin" }
        ]
    },
    { label : "After purchase", value : "afterPurchase" ,defaultLabel: "Send to ",linkOpenOptions : true,
        data : [
            { label : "Product description page" , value : "productPage" },
            { label : "Course player" , value : "pathPlayer" },
            { label : "After login page" , value : "afterLogin" }
        ]
    },
    { label: "Social Share", value: "socialShare", defaultLabel: "Share on: ", linkOpenOptions: false,
        data : [
            { label : "Facebook" , value : "facebook" },
            { label : "Twitter" , value : "twitter" },
            { label : "Linkedin" , value : "linkedin" },
            //{ label : "Pinterest" , value : "pinterest" }, will implement later
        ]
    },

    { label: "Forms", value : "openformslink", defaultLabel: "Select form",linkOpenOptions : false,
        data : [
            { label : "Sign in form", value : "signin"},
            { label : "Sign up form", value : "signup" },
            { label : "Reset password form", value : "resetpassword" }
        ]
    },

    { label: "URL", value : "weblink" , placeholder:"https://www.google.com", defaultLabel : "Select the url",linkOpenOptions : true, hrefValue: "{x}", usesHref: true},

    { label: "Scroll into the page", value : "scrolllink" , dataSource: 'sections', defaultLabel : "Select section" , linkOpenOptions : false},

    { label: "Email", value : "emaillink" ,placeholder:"" , defaultLabel : "Select email", linkOpenOptions : false, hrefValue: "mailto:{x}" , usesHref: true},

    { label : "Signout", value : "signout" ,usesHref: true ,hrefValue: "/signout"},

    // { label : "Resume Course", value : "resumeCourse" },
];
